import { render } from "./EventEdit.vue?vue&type=template&id=cdf287fa&scoped=true"
import script from "./EventEdit.vue?vue&type=script&lang=js"
export * from "./EventEdit.vue?vue&type=script&lang=js"

import "./EventEdit.vue?vue&type=style&index=0&id=cdf287fa&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdf287fa"]])

export default __exports__